import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { capturePasswordResetLink } from "./lib/auth/passwordResetLink";
import "./styles/global.css";

capturePasswordResetLink();

const container = document.getElementById("root");
if (!container) throw new Error("Root element #root not found.");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
